export default __webpack_public_path__ + "images/92e2a9a8f973c0016f856f8cb01a03ed.svg";